"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Cube = function Cube(_ref) {
  var onClick = _ref.onClick,
      scaling = _ref.scaling,
      shades = _ref.shades,
      size = _ref.size,
      stroke_width = _ref.stroke_width,
      stroke = _ref.stroke;
  var origin = {
    x: 0,
    y: size - 115 * scaling
  };
  var vertex = {
    y: 29 * scaling,
    yy: 57 * scaling,
    yyy: 87 * scaling,
    yyyy: 115 * scaling,
    x: 50 * scaling,
    xx: 100 * scaling
  };
  var faces = ["M ".concat(origin.x, ",").concat(origin.y + vertex.y, " \n        L \n        ").concat(origin.x, ", ").concat(origin.y + vertex.yyy, "\n        ").concat(origin.x + vertex.x, ", ").concat(origin.y + vertex.yyyy, "\n        ").concat(origin.x + vertex.x, ", ").concat(origin.y + vertex.yy, "\n        ").concat(origin.x, ",").concat(origin.y + vertex.y, "\n      z"), "M ".concat(origin.x, ",").concat(origin.y + vertex.y, " \n        L \n        ").concat(origin.x + vertex.x, ", ").concat(origin.y + vertex.yy, "\n        ").concat(origin.x + vertex.xx, ", ").concat(origin.y + vertex.y, "\n        ").concat(origin.x + vertex.x, ", ").concat(origin.y, "\n       ").concat(origin.x, ",").concat(origin.y + vertex.y, "\n      z"), "M ".concat(origin.x + vertex.x, ",").concat(origin.y + vertex.yy, " \n        L \n        ").concat(origin.x + vertex.x, ", ").concat(origin.y + vertex.yyyy, "\n        ").concat(origin.x + vertex.xx, ", ").concat(origin.y + vertex.yyy, "\n        ").concat(origin.x + vertex.xx, ", ").concat(origin.y + vertex.y, "\n        ").concat(origin.x + vertex.x, ",").concat(origin.y + vertex.yy, "\n      z\n      ")];
  return _react["default"].createElement("g", {
    "aria-hidden": "true",
    stroke: stroke,
    strokeWidth: stroke_width,
    onClick: onClick,
    style: {
      cursor: 'pointer'
    }
  }, faces.map(function (f, i) {
    return _react["default"].createElement("path", {
      key: "".concat(i, "-face"),
      d: f,
      fill: (0, _utils.RGB_Linear_Shade)(i * 16 / 100, shades)
    });
  }));
};

var _default = Cube;
exports["default"] = _default;